import { useParams } from "react-router-dom";
import { Card } from "primereact/card";
import { useSelector } from "react-redux";
import CustomeButton from "~/components/Button";
import AdminOnly from "~/components/AdminOnly";
import FileUploadModal from "~/components/Processes/conversations/FileUploadModal";
import Notification from "~/components/entities/notification/Notification";

import useAttachments from "../../actions/useAttachments";
import AttachmentTable from "./AttachmentTable";
import TemporaryNotification from "~/components/toast-notification/AttachmentTemporaryNotification";
import DocumentConfirmationDialog from "~/components/confirmation-dialog/DocumentConfirmationDialog";
import AttachmentSuccess from "~/components/toast-notification/AttachmentSuccess";
import AttachmentConfirmDialog from "~/components/AttachmentConfirmationModal/AttachmentConfirmDialog";
import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import API_ROUTES_V2 from "~/api-routes-v2";

const EmployeeAttachments = () => {
  const { id } = useParams();
  const { role } = useSelector((state) => state.login);
  const {
    state,
    setShowUploadModal,
    getNameForFile,
    uploadFileHandler,
    handleChangePage,
    handleDeleteDocument,
    setAttachmentConfirmModal,
    handleConfirmDelete,
    setSuccessMessage,
    handleRestoreAttachment,
    setTemporaryMessage,
    setRstoreMessage,
    setShowAttachmentConfirmation,
    setFiles,
    setAuditSidebarVisible,
  } = useAttachments();

  const auditLabels = () => {
    return {
      create: "File Uploaded",
      update: "File Updated",
      delete: "File(s) Deleted",
    };
  };

  return (
    <>
      <Card className="card-onboard attachment-card">
        <div className="flex justify-content-between align-items-center mb-5">
          <p className="heading m-0 mb-2">Attachments</p>
          <div className="flex gap-2">
            <AdminOnly>
              <CustomeButton
                label="View History"
                icon="pi pi-history"
                iconPos="right"
                onClick={() => setAuditSidebarVisible(true)}
              />
            </AdminOnly>
            {["GXM_ADMIN", "LSP_USER", "LSP_MANAGER"].includes(role) && (
              <CustomeButton
                label="Upload File"
                variant="contained"
                icon="pi pi-plus"
                iconPos="right"
                onClick={() => {
                  setShowUploadModal(true);
                }}
              />
            )}
          </div>
        </div>
        <Notification
          successMessage={state?.successMessage}
          setSuccessMessage={setSuccessMessage}
        />
        <TemporaryNotification
          onUndo={handleRestoreAttachment}
          successMsg={state?.temporaryMessage}
          setMessages={setTemporaryMessage}
        />
        <AttachmentSuccess
          successMsg={state?.restoreMessage}
          setMessages={setRstoreMessage}
        />
        <div className="formgrid grid mt-4">
          <div className="col-12">
            <AttachmentTable
              files={state?.filesData}
              isDataAvailable={state?.isFileAvailable}
              loading={state?.loading}
              first={state?.first}
              rows={state?.rows}
              onPageChange={handleChangePage}
              setOpenDialog={setShowUploadModal}
              handleAttachmentDelete={handleDeleteDocument}
            />
          </div>
        </div>

        <FileUploadModal
          entitydata={state?.entityData}
          showModal={state?.showUploadModal}
          fileSupported={state?.fileSupported}
          hideUploadModal={() => setShowUploadModal(false)}
          setUploadedFile={(files) => {
            if (["LSP_USER", "LSP_MANAGER"].includes(role)) {
              setShowAttachmentConfirmation(true);
              setFiles(files);
            } else {
              uploadFileHandler(files);
            }
          }}
          getService={getNameForFile}
          placeholder={"Choose a file to upload"}
          loading={state?.isFileUploaded}
          close={false}
          employeeData={state?.employeeDetails}
          isEmployeeAttachment={true}
        />
        {state?.attachmentConfirmModal && (
          <DocumentConfirmationDialog
            visible={state?.attachmentConfirmModal}
            closeModal={() => setAttachmentConfirmModal(false)}
            handleSave={handleConfirmDelete}
            isLoader={state?.isAttachmentLoader}
          />
        )}
        {state?.showAttachmentConfirmation && (
          <AttachmentConfirmDialog
            showModal={state?.showAttachmentConfirmation}
            handleCloseModal={() => setShowAttachmentConfirmation(false)}
            handleConfirm={() => {
              uploadFileHandler(state.files);
              setShowAttachmentConfirmation(false);
            }}
            message="Please double check that you are uploading the correct document. Do not share private or personal information with the wrong recipient."
          />
        )}
        {state.isAuditSidebarVisible && (
          <AuditSidebar
            heading="Attachments"
            endpoint={API_ROUTES_V2.FETCH_ATTACHMENT_AUDIT}
            id={id}
            objectType="EMPLOYEE"
            setSidebarToggle={setAuditSidebarVisible}
            sidebarToggle={state.isAuditSidebarVisible}
            labels={auditLabels}
          />
        )}
      </Card>
    </>
  );
};
export default EmployeeAttachments;
